import { render, staticRenderFns } from "./NewStorageFolderModal.vue?vue&type=template&id=6b43a51e&lang=pug"
import script from "./NewStorageFolderModal.vue?vue&type=script&lang=js"
export * from "./NewStorageFolderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports